export default "__VITE_ASSET__BT6g4E9Q__"